import React from 'react';
import { usePlayerContext } from '../../context/player-context';

export const BufferingSpinner: React.FC = () => {
  const { isBuffering, isPlaying } = usePlayerContext();

  // Only show spinner when buffering and the player is not paused
  if (!isBuffering || !isPlaying) {
    return null;
  }

  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-25">
      <div className="p-3 bg-black bg-opacity-50 rounded-full">
        <div
          className="w-12 h-12 border-4 border-t-4 border-white border-opacity-75 rounded-full animate-spin"
          style={{ borderTopColor: 'transparent' }}
        ></div>
      </div>
    </div>
  );
};
